<template>
  <div class="flex items-center">
    <div class="mr-2">
      <img src="/assets/img/code/Mrs.Chai.png" width="88" />
    </div>
    <div class="text-small leading-22">
      <div>
        <span class="text-theme-black-450">客服顾问：</span>
        <span class="text-theme-black-850">柴女士</span>
      </div>
      <div>
        <span class="text-theme-black-450">联系电话：</span>
        <span class="text-theme-black-850">18511821229</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettlementCustomer'
}
</script>

<style scoped></style>
